import { type AvailableDates, type DailySlot } from '@avanta/shared/types/appointments';

export const mergeAvailableDates = (dailySlots: DailySlot[]): AvailableDates =>
  dailySlots.reduce<AvailableDates>((dates, slot) => {
    dates[slot.date] = [...new Set([...(dates[slot.date] ?? []), ...slot.times])].sort();
    return dates;
  }, {});
